import { Arsenal, Libre_Caslon_Text, Roboto } from 'next/font/google';

const libreCaslonTextFont = Libre_Caslon_Text({
  weight: ['400', '700'],
  style: ['normal'],
  subsets: ['latin'],
});

const arsenalFont = Arsenal({
  weight: ['400', '700'],
  subsets: ['latin'],
});

const robotoFont = Roboto({
  weight: ['400', '700', '900'],
  style: ['normal'],
  subsets: ['latin'],
});

export { arsenalFont, libreCaslonTextFont, robotoFont };
